export const openedModalZindexList: Array<number> = [];

let scrollLockCount = 0;
let savedScrollY = 0;
let savedBodyOverflow = "";
let savedBodyPosition = "";
let savedBodyTop = "";
let savedBodyLeft = "";
let savedBodyRight = "";
let savedBodyWidth = "";

export function acquireModalScrollLock(): void {
  if (scrollLockCount === 0) {
    savedScrollY = window.scrollY;
    savedBodyOverflow = document.body.style.overflow;
    savedBodyPosition = document.body.style.position;
    savedBodyTop = document.body.style.top;
    savedBodyLeft = document.body.style.left;
    savedBodyRight = document.body.style.right;
    savedBodyWidth = document.body.style.width;

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = scrollbarWidth > 0 ? `calc(100% - ${scrollbarWidth}px)` : "100%";
  }
  scrollLockCount++;
}

export function releaseModalScrollLock(): void {
  if (scrollLockCount === 0) {
    return;
  }

  scrollLockCount = Math.max(0, scrollLockCount - 1);
  if (scrollLockCount === 0) {
    const scrollYToRestore = savedScrollY;

    document.body.style.overflow = savedBodyOverflow;
    document.body.style.position = savedBodyPosition;
    document.body.style.top = savedBodyTop;
    document.body.style.left = savedBodyLeft;
    document.body.style.right = savedBodyRight;
    document.body.style.width = savedBodyWidth;

    if (window.scrollY !== scrollYToRestore) {
      window.scrollTo({ left: 0, top: scrollYToRestore, behavior: "instant" });
    }
  }
}
